// loadGoogleMapsApi.js
export function loadGoogleMapsApi(apiKey) {
    return new Promise((resolve, reject) => {
        if (
            window.google &&
            window.google.maps &&
            window.google.maps.places &&
            window.google.maps.places.AutocompleteSuggestion
        ) {
            resolve(window.google);
            return;
        }

        const existingScript = document.getElementById("google-maps-script");
        if (existingScript) {
            existingScript.addEventListener("load", () => resolve(window.google));
            existingScript.addEventListener("error", reject);
            return;
        }

        const script = document.createElement("script");
        script.id = "google-maps-script";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=beta`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            if (
                window.google &&
                window.google.maps &&
                window.google.maps.places &&
                window.google.maps.places.AutocompleteSuggestion
            ) {
                resolve(window.google);
            } else {
                reject(
                    new Error(
                        "Google Maps API loaded but AutocompleteSuggestion not available."
                    )
                );
            }
        };

        script.onerror = () => reject(new Error("Failed to load Google Maps API"));

        document.head.appendChild(script);
    });
}
